import { FunctionComponent } from "react";
import BannerKountries from "@Components/molecules/BannerKountries";
import Footer from "@Components/organisms/Footer";
import Header from "@Components/organisms/Header";
import Home from "@Components/organisms/Home";
import WithGlobalLoader from "@Components/WithGlobalLoader";

const HomePage: FunctionComponent = () => {
  return (
    <>
      <BannerKountries />
      <Header />
      <WithGlobalLoader initialLoading={true} type="home">
        <Home />
      </WithGlobalLoader>
      <Footer />
    </>
  );
};

export default HomePage;
